import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

interface LogInProps {
  handleLogin: (e: React.FormEvent, email: string, password: string) => void;
  isAuthenticated: boolean;
}

const LogIn: React.FC<LogInProps> = ({ handleLogin, isAuthenticated }) => {
  console.log(isAuthenticated);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  return isAuthenticated ? (
    <Navigate replace to={process.env.PUBLIC_URL + "/input"} />
  ) : (
    <div>
      <h1>Login</h1>
      <form onSubmit={(e) => handleLogin(e, email, password)}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Sign in</button>
      </form>
    </div>
  );
};

export default LogIn;